import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { SubscriptionsDataQuotaResponse } from "@/types/subscriptions";

import { getSubscriptionsDataQuota } from "./subscriptionsApi";

export const useSubscription = (
  options?: Omit<
    UseQueryOptions<
      SubscriptionsDataQuotaResponse,
      Error,
      SubscriptionsDataQuotaResponse
    >,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery({
    queryKey: ["subscriptions"],
    queryFn: getSubscriptionsDataQuota,
    ...options
  });
};
